import type { BadgeColor } from '@civilgrid/ui/components';

// Same types and colors as the CivilSearch asset-type badges. Kept here because `/civilsearch` is deprecated.
const ASSET_TYPES = [
  'Cable',
  'Community Development District',
  'Electric',
  'Fiber',
  'Fiber-to-the-Premises',
  'Gas',
  'Geotech',
  'Moratoriums',
  'None',
  'Other',
  'Paving Projects',
  'Petroleum',
  'Pipeline',
  'Projects',
  'Railroad',
  'Recycled',
  'Sewer',
  'Steam',
  'Storm',
  'Telco',
  'Unknown',
  'Water',
] as const;

export type AssetType = (typeof ASSET_TYPES)[number];

export const assetTypeColor: Record<AssetType, BadgeColor> = {
  Cable: 'red',
  'Community Development District': 'green',
  Electric: 'red',
  Fiber: 'orange',
  'Fiber-to-the-Premises': 'orange',
  Gas: 'yellow',
  Geotech: 'yellow',
  Moratoriums: 'purple',
  None: 'grey',
  Other: 'grey',
  'Paving Projects': 'purple',
  Petroleum: 'yellow',
  Pipeline: 'yellow',
  Projects: 'purple',
  Railroad: 'grey',
  Recycled: 'purple',
  Sewer: 'green',
  Steam: 'grey',
  Storm: 'green',
  Telco: 'orange',
  Unknown: 'grey',
  Water: 'blue',
};
